import { render, staticRenderFns } from "./tskreport.vue?vue&type=template&id=1b4b65f5&scoped=true&"
import script from "./tskreport.vue?vue&type=script&lang=js&"
export * from "./tskreport.vue?vue&type=script&lang=js&"
import style1 from "./tskreport.vue?vue&type=style&index=1&id=1b4b65f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4b65f5",
  null
  
)

export default component.exports